var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L16.5 5.5H12.375V0H9.625V5.5H5.5L11 11ZM15.9995 8.7505L14.4581 10.2919L20.0461 12.375L11 15.7479L1.95388 12.375L7.54188 10.2919L6.0005 8.7505L0 11V16.5L11 20.625L22 16.5V11L15.9995 8.7505Z",
    fill: "#9053F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReceiptIcon);
export default __webpack_public_path__ + "static/media/downloadReceiptIcon.21745220ffa2e395ec411d1c86f02e6e.svg";
export { ForwardRef as ReactComponent };